import { createBrowserRouter } from "react-router-dom";
import Analytics from "../pages/analytics/Analytics";
import Dashboard from "../pages/dashboard/Dashboard";
import DeletedUsers from "../pages/deleted-users/DeletedUsers";
import ErrorPage from "../pages/error-page/error-page";
import GroupPhotos from "../pages/group-photos/GroupPhotos";
import Groups from "../pages/groups/Groups";
import LoginPage from "../pages/login/LoginPage";
import MatchVideos from "../pages/match-videos/MatchVideos";
import NewsPage from "../pages/news/NewsPage";
import PhotoVerify from "../pages/photo-verify/PhotoVerify";
import PostReview from "../pages/post-review/PostReview";
import PrivatePhotos from "../pages/private-photos/PrivatePhotos";
import PrivateVideos from "../pages/private-videos/PrivateVideos";
import ProfilePhotos from "../pages/profile-photos/ProfilePhotos";
import PushSend from "../pages/push-send/PushSend";
import ReelComments from "../pages/reel-comments/ReelComments";
import Reels from "../pages/reels/Reels";
import SignupFlow from "../pages/signup-flow/SignupFlow";
import OnboardingFlow from "../pages/onboarding-flow/OnboardingFlow";
import OnboardingAnalytics from "../pages/onboarding-analytics/OnboardingAnalytics";
import PaidConversion from "../pages/paid-conversion/PaidConversion";
import { Chat } from "../pages/chat";
import { ChatMessages } from "../pages/chat-messages";
import Subscriptions from "../pages/subscriptions/Subscriptions";
import Support from "../pages/support/Support";
import SurveysList from "../pages/surveys/SurveysList";
import SurveyAnalytics from "../pages/surveys/SurveyAnalytics";
import UnresolvedReports from "../pages/unresolved-reports/UnresolvedReports";
import UnverifiedPhotos from "../pages/unverified-photos/UnverifiedPhotos";
import UnverifiedVideos from "../pages/unverified-videos/UnverifiedVIdeos";
import StorefrontMap from "../pages/storefront-map/StorefrontMap";
import UserActivityMap from "../pages/user-activity/UserActivityMap";
import UserPage from "../pages/user/UserPage";
import UsersPage from "../pages/users/UsersPage";
import LiveStreams from "../pages/live-streams/LiveStreams";
import VideoChatStatus from "../pages/video-chat-status/VideoChatStatus";
import VideoChatHistory from "../pages/video-chat-history/VideoChatHistory";
import VoiceRecordings from "../pages/voice-recordings/VoiceRecordings";
import { RequireAuth } from "./RequireAuth";
import Root from "./Root";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: (
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        ),
      },
      {
        path: "/users",
        element: (
          <RequireAuth>
            <UsersPage />
          </RequireAuth>
        ),
      },
      {
        path: "/deleted-users",
        element: (
          <RequireAuth>
            <DeletedUsers />
          </RequireAuth>
        ),
      },
      {
        path: "/user-activity",
        element: (
          <RequireAuth>
            <UserActivityMap />
          </RequireAuth>
        ),
      },
      {
        path: "/storefront-map",
        element: (
          <RequireAuth>
            <StorefrontMap />
          </RequireAuth>
        ),
      },
      {
        path: "/subscriptions",
        element: (
          <RequireAuth>
            <Subscriptions />
          </RequireAuth>
        ),
      },
      {
        path: "/paid-conversion",
        element: (
          <RequireAuth>
            <PaidConversion />
          </RequireAuth>
        ),
      },
      {
        path: "/surveys",
        element: (
          <RequireAuth>
            <SurveysList />
          </RequireAuth>
        ),
      },
      {
        path: "/surveys/:surveyId/analytics",
        element: (
          <RequireAuth>
            <SurveyAnalytics />
          </RequireAuth>
        ),
      },
      {
        path: "/push-send",
        element: (
          <RequireAuth>
            <PushSend />
          </RequireAuth>
        ),
      },
      {
        path: "/signup-flow",
        element: (
          <RequireAuth>
            <SignupFlow />
          </RequireAuth>
        ),
      },
      {
        path: "/onboarding-flow",
        element: (
          <RequireAuth>
            <OnboardingFlow />
          </RequireAuth>
        ),
      },
      {
        path: "/onboarding-analytics",
        element: (
          <RequireAuth>
            <OnboardingAnalytics />
          </RequireAuth>
        ),
      },
      {
        path: "/unverified-photos",
        element: (
          <RequireAuth>
            <UnverifiedPhotos />
          </RequireAuth>
        ),
      },
      {
        path: "/unverified-videos",
        element: (
          <RequireAuth>
            <UnverifiedVideos />
          </RequireAuth>
        ),
      },
      {
        path: "/profile-photos",
        element: (
          <RequireAuth>
            <ProfilePhotos />
          </RequireAuth>
        ),
      },
      {
        path: "/match-videos",
        element: (
          <RequireAuth>
            <MatchVideos />
          </RequireAuth>
        ),
      },
      {
        path: "/photo-verify",
        element: (
          <RequireAuth>
            <PhotoVerify />
          </RequireAuth>
        ),
      },
      {
        path: "/group-photos",
        element: (
          <RequireAuth>
            <GroupPhotos />
          </RequireAuth>
        ),
      },
      {
        path: "/groups",
        element: (
          <RequireAuth>
            <Groups />
          </RequireAuth>
        ),
      },
      {
        path: "/post-review",
        element: (
          <RequireAuth>
            <PostReview />
          </RequireAuth>
        ),
      },
      {
        path: "/analytics",
        element: (
          <RequireAuth>
            <Analytics />
          </RequireAuth>
        ),
      },
      {
        path: "/reels",
        element: (
          <RequireAuth>
            <Reels />
          </RequireAuth>
        ),
      },
      {
        path: "/reel-comments",
        element: (
          <RequireAuth>
            <ReelComments />
          </RequireAuth>
        ),
      },
      {
        path: "/private-photos",
        element: (
          <RequireAuth>
            <PrivatePhotos />
          </RequireAuth>
        ),
      },
      {
        path: "/private-videos",
        element: (
          <RequireAuth>
            <PrivateVideos />
          </RequireAuth>
        ),
      },
      {
        path: "/unresolved-reports",
        element: (
          <RequireAuth>
            <UnresolvedReports />
          </RequireAuth>
        ),
      },
      {
        path: "/user/:id",
        element: (
          <RequireAuth>
            <UserPage />
          </RequireAuth>
        ),
      },
      {
        path: "/news",
        element: (
          <RequireAuth>
            <NewsPage />
          </RequireAuth>
        ),
      },
      {
        path: "/chat",
        element: (
          <RequireAuth>
            <Chat />
          </RequireAuth>
        ),
      },
      {
        path: "/chat-messages",
        element: (
          <RequireAuth>
            <ChatMessages />
          </RequireAuth>
        ),
      },
      {
        path: "/voice-recordings",
        element: (
          <RequireAuth>
            <VoiceRecordings />
          </RequireAuth>
        ),
      },
      {
        // One route for the list and an open ticket, so the filters survive
        // moving between tickets
        path: "/support/:id?",
        element: (
          <RequireAuth>
            <Support />
          </RequireAuth>
        ),
      },
      {
        path: "/live-streams",
        element: (
          <RequireAuth>
            <LiveStreams />
          </RequireAuth>
        ),
      },
      {
        path: "/video-chat-status",
        element: (
          <RequireAuth>
            <VideoChatStatus />
          </RequireAuth>
        ),
      },
      {
        path: "/video-chat-history",
        element: (
          <RequireAuth>
            <VideoChatHistory />
          </RequireAuth>
        ),
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
    ],
  },
]);

export default router;
